import {atom} from 'jotai';
export const searchQueryAtom = atom('');
export const isSearchLoadingAtom = atom(false);
